import React from "react";

function PackageCancellation() {
  return <div>PackageCancellation</div>;
}

export default PackageCancellation;
